// Public destinations used across the site. Keep them in one place so the header, hero and
// footer can't drift apart.
export const APP_STORE_URL = 'https://apps.apple.com/us/app/jugglevision/id6748683730';
export const CONTACT_EMAIL = 'jugglevision@lccode.dev';
